import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/layout/Layout';

import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import Dashboard from './pages/dashboard/Dashboard';
import EmployeeList from './pages/employees/EmployeeList';
import AddEmployee from './pages/employees/AddEmployee';
import EditEmployee from './pages/employees/EditEmployee';
import EmployeeDetail from './pages/employees/EmployeeDetail';
import DepartmentList from './pages/departments/DepartmentList';
import LeaveList from './pages/leaves/LeaveList';
import AttendancePage from './pages/attendance/AttendancePage';
import PayrollPage from './pages/payroll/PayrollPage';
import SettingsPage from './pages/settings/SettingsPage';
import LeaveBalanceList from './pages/leaves/LeaveBalanceList';
import HolidayList from './pages/holidays/HolidayList';
import CalendarPage from './pages/calendar/CalendarPage';
import ProjectList from './pages/projects/ProjectList';
import CreateProject from './pages/projects/CreateProject';
import ProjectBoard from './pages/projects/ProjectBoard';
import TaskDetail from './pages/projects/TaskDetail';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="employees" element={<EmployeeList />} />
            <Route path="employees/add" element={<ProtectedRoute allowedRoles={['admin', 'hr']}><AddEmployee /></ProtectedRoute>} />
            <Route path="employees/:id" element={<EmployeeDetail />} />
            <Route path="employees/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'hr']}><EditEmployee /></ProtectedRoute>} />
            <Route path="departments" element={<DepartmentList />} />
            <Route path="leaves" element={<LeaveList />} />
            <Route path="leave-balances" element={<ProtectedRoute allowedRoles={['admin', 'hr']}><LeaveBalanceList /></ProtectedRoute>} />
            <Route path="holidays" element={<HolidayList />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="projects" element={<ProjectList />} />
            <Route path="projects/new" element={<ProtectedRoute allowedRoles={['admin', 'hr']}><CreateProject /></ProtectedRoute>} />
            <Route path="projects/:id" element={<ProjectBoard />} />
            <Route path="projects/:id/edit" element={<ProtectedRoute allowedRoles={['admin', 'hr']}><CreateProject /></ProtectedRoute>} />
            <Route path="projects/:id/tasks/:taskId" element={<TaskDetail />} />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="payroll" element={<PayrollPage />} />
            <Route path="register" element={<ProtectedRoute allowedRoles={['admin']}><RegisterPage /></ProtectedRoute>} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
